module.exports = __webpack_public_path__ + "assets/img/e80a-es-ga.svg";